import { Flex, Text } from '@mantine/core';
import { BaseLayout } from '../../navigation';
import classes from '../../../../sharedStyles/InfoCard.module.css';
import { useKeycloakStore, useShopStore } from '../../../../store';
import { useAvailableThcAmount, useWindowSize } from '../../../../hooks';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ProductList } from './components/ProductList';
import { FeatureAccess } from '../../../../util/ff/FeatureAccess';
import { FeatureFlag, RealmRole } from '@web/common';
import { OpenOrders } from './components/OpenOrders';
import { ShoppingCartButton } from '../../../../component/button';

export const ShopScreen = observer(() => {
  const shopStore = useShopStore();
  const products = shopStore.products;
  const isSmallScreen = useWindowSize(500);
  const { t } = useTranslation('shop');
  const { currentThcUnit, availableAmount } = useAvailableThcAmount();
  const kcStore = useKeycloakStore();
  const currentRole = kcStore.currentRealmRole;

  useEffect(() => {
    shopStore.loadProducts();
  }, [shopStore]);

  return (
    <BaseLayout>
      <Flex
        direction="column"
        maw={1100}
        gap={20}
        bg="#fff"
        align="flex-start"
        p={isSmallScreen ? 20 : 40}
        className={classes.borderRadius}
      >
        <FeatureAccess flag={FeatureFlag.Shop_Checkout}>
          <OpenOrders />
        </FeatureAccess>
        <Text fw="500" size="28px" lh="38px">
          {t('Title')}
        </Text>
        <Text size="14px" lh="21px">
          {t('AvailableAmountMessage', { availableAmount, currentThcUnit })}
        </Text>

        <ProductList products={products} />
        <FeatureAccess flag={FeatureFlag.Shop_Checkout}>
          {currentRole === RealmRole.Participant && isSmallScreen && (
            <ShoppingCartButton isMobile />
          )}
        </FeatureAccess>
      </Flex>
    </BaseLayout>
  );
});
